import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';
import HeaderWithoutLang from './components/HeaderWithoutLang/HeaderWithoutLang';
import Home from './page/Home/Home';
import About from './page/About/About';
import Team from './page/Team/Team';
import News from './page/News/News';
import FooterWithoutLang from './components/FooterWithoutLang/FooterWithoutLang';

import TagManager from 'react-gtm-module';

import styled from 'styled-components';

function Handle404() {
  const location = useLocation();

  window.location.replace(
    'https://intelliquant.ai' + location.pathname + location.search
  );
  return null;
}

export default function App() {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
  };

  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <Router>
      <StyledWrapper>
        <HeaderWithoutLang />
        <Switch>
          <Route exact path="/" render={() => <Home />} />
          <Route exact path="/about" render={() => <About />} />
          <Route exact path="/team" render={() => <Team />} />
          <Route exact path="/news" render={() => <News />} />
          <Route path="*" component={Handle404} />
        </Switch>
        <FooterWithoutLang />
      </StyledWrapper>
    </Router>
  );
}

const StyledWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;
